import React, { useEffect, useState } from 'react'
import axios from 'axios'
import key from '../key'
import logo from '../images/transLogo.svg'
import { Link } from 'react-router-dom';

const TermAndConditions = () => {
    const [termsAndConditions, setTermsAndConditions] = useState('');

    const getSiteSettings = async () => {
        await axios.get(`${key}/api/admin/get-site-settings`)
            .then((res) => {
                setTermsAndConditions(res?.data?.setting?.termsAndConditions);
            })
            .catch((err) => console.log(err));
    }
    useEffect(() => {

        getSiteSettings();
        //eslint-disable-next-line
    }, [])
    return (
        <div className='mx-4'>
            <div style={{alignItems:'center'}} className='d-flex justify-content-between'>
                <Link to='/'>
                    <button className='back-buttonss'>Go Back to Home Page</button>
                </Link>
                <div className='web-name'>Lovodi.com</div>
                <div>
                    <img style={{width:200}} src={logo} alt="lovodi" />
                </div>
            </div>
            <div dangerouslySetInnerHTML={{ __html: termsAndConditions }} />
        </div>
    )
}

export default TermAndConditions
